import NodeWrapper from "./NodeWrapper";
import { getPointsFromLs, scale, distance } from './Geometry';
import { combinations, argmin } from './utils';

let indexPairings = combinations([0,1,2,3]).filter(x => x.length === 2);


function getTargetNodeSelector(cellLocation,targetNodeId){
  return (`[cell="${cellLocation.join('-')}"] [nodeid="${targetNodeId}"]`)
}


function getDomNodePoints(cellLocation, targetNodeId){

  let selector = getTargetNodeSelector(cellLocation,targetNodeId)
  let targetNodeDiv = document.querySelector(selector);

  if( !targetNodeDiv ){
    return null;
  }

  let targetBounds = targetNodeDiv.getBoundingClientRect();

  let pointsOnNode = [
      [targetBounds.left, targetBounds.top],
      [targetBounds.left + targetBounds.width, targetBounds.top],
      [targetBounds.left + targetBounds.width, targetBounds.top + targetBounds.height],
      [targetBounds.left, targetBounds.top + targetBounds.height]
    ]

  return pointsOnNode;

}

function getPointsRelativeToBounds(containerBounds, outlinePoints){

  return outlinePoints.map(p => ([p[0] - containerBounds.left,p[1]-containerBounds.top]))
}

function Line({points,strokeWidth=1,strokeDasharray,stroke="white",nodeId}){
  let pair = points;
  return (
    <>
    <line nodeId={nodeId} item="leader-line" style={{
      pointerEvents:'auto',
    }} class="thick-on-hover" {...{
      x1:pair[0][0],
      y1:pair[0][1],
      x2:pair[1][0],
      y2:pair[1][1],
      stroke,
      strokeWidth,
      strokeDasharray,
    }}/>

    <line nodeId={nodeId} item="leader-line" style={{
      pointerEvents:'auto',
    }} class="thick-on-hover" {...{
      x1:pair[0][0],
      y1:pair[0][1],
      x2:pair[1][0],
      y2:pair[1][1],
      stroke:"transparent",
      strokeWidth,
      //strokeDasharray,
    }}/>

    </>
  )
}

function getCombinations(arr,n){

}

function getRegionOutlinePoints(atn, containerBounds){
  let { ls, height } = atn;

  let scaledHeight = containerBounds.width * height;
    let scaledLs = ls?.map(scale(containerBounds.width));
    let outlinePoints = getPointsFromLs(scaledLs,scaledHeight);
  return outlinePoints;

}

function getPairOfPointsWithMinimumTotalDistance({pointsOnNode,outlinePoints}){

  let minPointPair = null;
  let minTotal = Number.POSITIVE_INFINITY;
  
  


  for(let ii = 0; ii < indexPairings.length; ii++){
    let np = [
      pointsOnNode[ indexPairings[ii][0] ],
      pointsOnNode[ indexPairings[ii][1] ]
    ]
    for(let jj = 0; jj < indexPairings.length; jj++){

      let op = [
        outlinePoints[ indexPairings[jj][0] ],
        outlinePoints[ indexPairings[jj][1] ]
      ]

      let linePair0 = [
      ]



      let linePairs = [
        [ [np[0],op[0]], [np[1],op[1]] ],
        [ [np[0],op[1]], [np[1],op[0]] ]
      ];



      let distSums = linePairs.map(linePair => {
        return distance(...linePair[0]) + distance(...linePair[1]);
      })

      //console.log(distSums);
        /*.map(linePoints => {
          
          return distance(...linePoints[0]) + distance(...linePoints[1])
        })
      })*/

      let minSum = Math.min(...distSums)
      if( minSum < minTotal ){
        minPointPair = linePairs[argmin(distSums)];
        minTotal = minSum;
      }
    }
  }



  return minPointPair;





}


export default function LeaderLines({
  atns,
  regions,
  regionIdToRegionOutlineNode,
  node,
  nodeId,
  nodes,
  cellLocation,
  containerBounds,
  selectedRegionOutlineId,
  selectedRegionId,
}){

  console.log(node);


  let linesToNodes = atns.map((atn,ii) => {


    let { _id } = atn;

    let regionId = Object.keys(regions).find(rid => regions[rid] === _id);


    let regionOutlineNode = regionIdToRegionOutlineNode[regionId];
    let shouldShowLeaderLines = (
      regionOutlineNode.style.visibility !== "hidden"
      &&
      regionOutlineNode.leaderLines.style.visibility !== "hidden"
    )

    if( !shouldShowLeaderLines ){
      return null;
    }

    let targetNodeId = Object.keys(nodes).find(nid => {
      let nd = nodes[nid];
      return nd?.value?.channelGroup === node.value.channelGroup && nd.type === "region" && nd.value.regionId === regionId;
    });

    //let tdSelector = (`td[cell="${cellLocation.join('-')}"]`)
    //let tdDiv = document.querySelector(tdSelector);

    let targetNodePoints = getDomNodePoints(cellLocation, targetNodeId);
    if( !targetNodePoints ){
      return null;
    }

    let pointsOnNode = getPointsRelativeToBounds(containerBounds,targetNodePoints);
    let outlinePoints = getRegionOutlinePoints(atn,containerBounds);

    let pointPairs = getPairOfPointsWithMinimumTotalDistance({pointsOnNode,outlinePoints})


    
    //first get closest outlinePoints in nodeId
    pointsOnNode.sort((a,b) => distance(outlinePoints[0], a) - distance(outlinePoints[0],b));

    let closestNodePointToOutline = pointsOnNode[0];

    outlinePoints.sort((a,b) => distance(a,pointsOnNode[0]) - distance(b,pointsOnNode[0]))
    let closestOutlinePoint = outlinePoints[0];


    let remainingPoints = outlinePoints.slice(1);
    remainingPoints.sort((a,b) => distance(a,pointsOnNode[1]) - distance(b,pointsOnNode[1]))



    const showCircles = false;

    let topMostPoint = outlinePoints.reduce((a,b) => a[1] < b[1] ? a : b,outlinePoints[0])

   
    console.log(regionOutlineNode);
    let linesFromPointPairs = pointPairs.map(line => (
      <Line 
        nodeId={nodeId}
        points={line} 
        strokeWidth={regionOutlineNode?.style?.borderThickness}
        strokeDasharray={regionOutlineNode?.style?.strokeDasharray}
        stroke={regionOutlineNode?.style?.borderColor}
      />
    ))

    return (
      <>
        {showCircles && outlinePoints.map(pp => {
          let [ cx, cy ] = pp;
          return (
            <circle cx={cx} cy={cy} r={3} fill="lime"/>
          )
        })}
        {linesFromPointPairs}
      </>
    )
  })

  return (
    <>
      {linesToNodes}
    </>
  )




}
